import { render, staticRenderFns } from "./BookMeetingCard.vue?vue&type=template&id=232bfdc4&scoped=true&"
import script from "./BookMeetingCard.vue?vue&type=script&lang=ts&"
export * from "./BookMeetingCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookMeetingCard.vue?vue&type=style&index=0&id=232bfdc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232bfdc4",
  null
  
)

export default component.exports